import { Link } from "react-router-dom";

export const TermsPage = () => {
  const lastUpdated = "April 2026";

  return (
    <div id="main-content" className="pt-20" data-testid="terms-page">
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="overline text-brand-primary mb-4">Legal</p>
          <h1 className="font-serif text-4xl sm:text-5xl font-light text-slate-900 leading-tight mb-4">
            Terms of Use
          </h1>
          <p className="text-sm text-slate-500 mb-10">Last updated: {lastUpdated}</p>

          <div className="prose-custom space-y-6 text-slate-700 leading-relaxed">
            <p>
              These Terms of Use govern your access to and use of the website of the Centre for
              Consciousness Studies Australia ("the Centre"). By using this website you agree to these
              terms. If you do not agree, please refrain from using the site.
            </p>

            <h2 className="font-serif text-2xl text-slate-900 mt-10 mb-4">Purpose of the Site</h2>
            <p>
              This website exists to communicate the research, publications, videos, and engagement
              activities of the Centre. Content is provided for informational and scholarly purposes.
            </p>

            <h2 className="font-serif text-2xl text-slate-900 mt-10 mb-4">Intellectual Property</h2>
            <p>
              All original written content, design elements, and research materials published on this
              site are the intellectual property of the Centre or their respective authors, unless stated
              otherwise. Peer-reviewed publications linked from this site remain subject to the terms of
              their respective publishers.
            </p>
            <p>
              You may view, download, and share this content for personal, academic, or non-commercial
              research purposes, provided the Centre is properly attributed. Commercial redistribution is
              not permitted without written permission.
            </p>

            <h2 className="font-serif text-2xl text-slate-900 mt-10 mb-4">Accuracy of Content</h2>
            <p>
              We aim to keep information on this site accurate and current. However, research is an
              evolving discipline: content may be updated or superseded. The Centre does not warrant
              that any information on the site is complete, current, or free from error.
            </p>

            <h2 className="font-serif text-2xl text-slate-900 mt-10 mb-4">External Links</h2>
            <p>
              The site links to external resources including academic publishers, conference proceedings,
              and video platforms. The Centre is not responsible for the content or practices of these
              third-party sites.
            </p>

            <h2 className="font-serif text-2xl text-slate-900 mt-10 mb-4">Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Use the site for any unlawful purpose;</li>
              <li>Attempt to disrupt or compromise the site's security or availability;</li>
              <li>
                Submit content through the contact form that is fraudulent, misleading, defamatory, or
                infringing.
              </li>
            </ul>

            <h2 className="font-serif text-2xl text-slate-900 mt-10 mb-4">Limitation of Liability</h2>
            <p>
              To the extent permitted by law, the Centre accepts no liability for any loss or damage
              arising from use of, or reliance on, information provided through this site.
            </p>

            <h2 className="font-serif text-2xl text-slate-900 mt-10 mb-4">Changes</h2>
            <p>
              We may revise these terms at any time. Continued use of the site after changes are posted
              constitutes acceptance of the revised terms.
            </p>

            <h2 className="font-serif text-2xl text-slate-900 mt-10 mb-4">Contact</h2>
            <p>
              For questions about these Terms, please{" "}
              <Link to="/contact" className="text-brand-primary hover:underline">
                contact the Centre
              </Link>
              .
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
